import * as types from '../actions/typeNames'
import { LOADER_VIEW } from '../actions/main'

const InitialState = {
    view: LOADER_VIEW,
    userId: "",
    selectedForm: null,
    asyncRequest: false
}

const main = (state=InitialState, action) => {
    switch(action.type){
        case types.SET_LOADER:
            return{
                ...state, 
                view:action.view, 
                asyncRequest: action.asyncRequest
            }
        case types.SET_USER_ID:
            return {
                ...state,
                userId: action.id
            }
        case types.SELECT_FORM:
            return {
                ...state,
                selectedForm: action.form
            }
        case types.SAVE_SUCCESS:
            return {
                ...state,
                selectedForm: action.form
            }
        default:
            return {...state};
    }
}

export default main;